//router.js
import React from 'react';
import {BrowserRouter as Router, Route, Redirect, Switch} from "react-router-dom";

// import Login from '../portal/Login';
import Frame from '../frame/Frame';
import Home from '../frame/Home';

import Demo from '../pages/demo/Demo';
import Index from '../pages/index/Index';
import Login from '../pages/login/Index';
import Detail from '../pages/detail/Index';
import Info from '../pages/info/Index';
import Notice from '../pages/notice/Index';
import Guide from '../pages/guide/Index';
import Information from '../pages/information/Index';
import Filling from '../pages/filling/Index';
import Query from '../pages/query/Index';

class FrameRouter extends React.Component {
    render() {
        return(
            <Router basename="/grade-individual">
                <Route exact path="/" component={Home}></Route>
                <Route path="/home" render={ ({match}) => {
                    // let access = sessionStorage.getItem("_user_access_");
                    // let token = sessionStorage.getItem("_user_token_"); 
                    let access = true;
                    let token = true; 

                    let URL = window.location.pathname;
                    if( URL.indexOf('null')>-1)
                    {
                        URL='/home'
                    }
                    else
                    {
                        URL = URL.replace("/grade-individual", "");
                    }
                    sessionStorage.setItem("_redirect_source_url", URL);
                   
                    if( access || token )
                    {
                        let pathBase = match.path;

                        return(
                            <Router basename="/grade-individual">
                                <Switch>
                                    <FrameRoute exact path={ pathBase + "/" } component={Home} model="home"/>
                                    <FrameRoute exact path={ pathBase + "/demo" } component={Demo}/>
                                    <FrameRoute exact path={ pathBase + "/index" } component={Index}/>
                                    <FrameRoute exact path={ pathBase + "/login" } component={Login}/>
                                    <FrameRoute exact path={ pathBase + "/detail" } component={Detail}/>
                                    <FrameRoute exact path={ pathBase + "/info" } component={Info}/>
                                    <FrameRoute exact path={ pathBase + "/notice" } component={Notice}/>
                                    <FrameRoute exact path={ pathBase + "/guide" } component={Guide}/>
                                    <FrameRoute exact path={ pathBase + "/information" } component={Information}/>
                                    <FrameRoute exact path={ pathBase + "/filling" } component={Filling}/>
                                    <FrameRoute exact path={ pathBase + "/query" } component={Query}/>
                                    
                               </Switch> 
                            </Router>
                        )
                    }
                    else
                    {
                        return (
                            <Redirect to="/index"/>
                        )
                    }
                }} ></Route>    
            </Router>   
        )
    }
}

const FrameRoute = ({component: Component, model, ...rest}) => (
    <Route {...rest} render={(props) => (
        <Frame model={model} >
            <Component {...props} />
        </Frame>
    ) } />
)


export default FrameRouter


